/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewfromlabel3Inputs */

const en_letterpreviewfromlabel3 = /** @type {(inputs: Letterpreviewfromlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

const pt_letterpreviewfromlabel3 = /** @type {(inputs: Letterpreviewfromlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Letterpreviewfromlabel3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewfromlabel3 = /** @type {((inputs?: Letterpreviewfromlabel3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewfromlabel3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewfromlabel3(inputs)
	return pt_letterpreviewfromlabel3(inputs)
});
export { letterpreviewfromlabel3 as "letterPreviewFromLabel" }